import { render, staticRenderFns } from "./member-data.vue?vue&type=template&id=54329cac&scoped=true&"
import script from "./member-data.vue?vue&type=script&lang=js&"
export * from "./member-data.vue?vue&type=script&lang=js&"
import style0 from "./member-data.vue?vue&type=style&index=0&id=54329cac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54329cac",
  null
  
)

export default component.exports